import { render, staticRenderFns } from "./ResponseOptions.vue?vue&type=template&id=2b68e9ba&"
import script from "./ResponseOptions.vue?vue&type=script&lang=js&"
export * from "./ResponseOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports